import { styled } from '@mui/system';
import { TextField, Box, IconButton, Typography } from '@mui/material';

export const TextFieldStyled = styled(TextField)(({ theme }) => ({
  width: '100%',
  textAlign: 'center',
  padding: '0.625rem 0',
  '& input': {
    fontSize: '35px',
    fontWeight: 700,
    textAlign: 'center',
    lineHeight: '3.125rem',
    fontFamily: 'Calibri',
    color: theme?.palette?.lightBlue,
    padding: 0
  }
}));

export const BoxStyled = styled(Box)({
  display: 'flex',
  width: '100%',
  justifyContent: 'center'
});

export const IconButtonStyled = styled(IconButton)(({ theme }) => ({
  border: `0.125rem solid ${theme?.palette?.lightBlue}`,
  height: '1.875rem',
  width: '1.875rem',
  '& svg': {
    color: theme?.palette?.lightBlue
  },
  '&:disabled': {
    border: '0.125rem solid #888b8d',
    '& svg': {
      color: '#888b8d'
    }
  }
}));

export const TypographyStyledSubHead = styled(Typography)(({ theme }) => ({
  textAlign: 'center',
  fontSize: '0.75rem',
  fontFamily: 'Calibri',
  fontWeight: 400,
  color: theme?.palette?.primaryDark
}));
